"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var react_1 = require("react");

exports.DataLayerContext = react_1.createContext(new ksys_app_template_1.helpers.GtmDataLayerHelper(function () {
  return {
    appTemplate: 'unknown',
    appGuid: 'unknown',
    configurationKey: 'unknown'
  };
}));